import { Link, useNavigate, useLocation } from "react-router-dom";
import { ScrollText, LogOut, Coins } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const Nav = () => {
  const { user, logout, entitlement } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  const link = (to, label, tid) => (
    <Link to={to} data-testid={tid}
      className={`overline transition-colors duration-150 hover:text-[#0f172a] ${pathname === to ? "text-[#0f172a]" : "text-slate-500"}`}>
      {label}
    </Link>
  );

  return (
    <header className="sticky top-0 z-20 border-b border-stone-200 bg-[#fafaf9]/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-12">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <span className="flex h-9 w-9 items-center justify-center bg-[#0f172a] text-white">
            <ScrollText className="h-4 w-4" />
          </span>
          <span className="font-display text-lg font-bold tracking-tight">Ledger<span className="text-slate-500">Check</span></span>
        </Link>

        <nav className="flex items-center gap-6">
          {link("/analyze", "Analyze", "nav-analyze")}
          {link("/bulk", "Day book", "nav-bulk")}
          {user && link("/history", "History", "nav-history")}
          {link("/pricing", "Pricing", "nav-pricing")}

          {user ? (
            <div className="flex items-center gap-3">
              <Link to="/pricing" data-testid="nav-credits"
                className="inline-flex items-center gap-1.5 border border-stone-300 px-3 py-1.5 font-mono-data text-xs text-slate-600 transition-colors duration-150 hover:border-[#0f172a] hover:text-[#0f172a]">
                <Coins className="h-3.5 w-3.5" />
                {entitlement ? (entitlement.unlimited ? "unlimited" : `${entitlement.reviews_left} left`) : "—"}
              </Link>
              <span className="hidden font-mono-data text-xs text-slate-600 lg:inline" data-testid="nav-user-email">{user.email}</span>
              <button onClick={doLogout} className="flex items-center gap-1.5 border border-stone-300 px-3 py-1.5 text-xs text-slate-600 transition-colors duration-150 hover:border-[#0f172a] hover:text-[#0f172a]" data-testid="logout-btn">
                <LogOut className="h-3.5 w-3.5" /> Sign out
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              {entitlement && (
                <span className="hidden items-center gap-1.5 border border-stone-300 px-3 py-1.5 font-mono-data text-xs text-slate-500 sm:inline-flex" data-testid="nav-guest-credits">
                  <Coins className="h-3.5 w-3.5" /> {entitlement.reviews_left} free left
                </span>
              )}
              <Button onClick={() => navigate("/login")} className="rounded-none bg-[#0f172a] text-white hover:bg-stone-800" data-testid="nav-login-btn">Sign in</Button>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};
